import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  AppBar,
  CssBaseline,
  Toolbar,
  List,
  IconButton,
  Typography,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StoreIcon from "@mui/icons-material/Store";
import BuildIcon from "@mui/icons-material/Build";

import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SettingsIcon from "@mui/icons-material/Settings";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { auth, db } from "../firebase-config";
import { doc, getDoc } from "firebase/firestore";

const drawerWidth = 240;

const Header = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loadingAdmin, setLoadingAdmin] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const currentUser = auth.currentUser;

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!currentUser) {
        setIsAdmin(false);
        setLoadingAdmin(false);
        return;
      }

      try {
        const adminRef = doc(db, "admins", currentUser.uid);
        const adminSnap = await getDoc(adminRef);
        setIsAdmin(adminSnap.exists());
      } catch (err) {
        console.error("Error checking admin status:", err);
      } finally {
        setLoadingAdmin(false);
      }
    };

    checkAdminStatus();
  }, [currentUser]);

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { text: "Home", icon: <HomeIcon />, path: "/" },
    { text: "Products", icon: <StoreIcon />, path: "/products" },
    { text: "Cart", icon: <ShoppingCartIcon />, path: "/cart" },  
    { divider: true },
    { text: "Quotes", icon: <RequestQuoteIcon  />, path: "/quotes" },
    { text: "Projects", icon: <BuildIcon />, path: "/projects" },
    { divider: true },
    { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
  ];

  if (isAdmin) {
    navItems.push({ text: "Admin", icon: <AdminPanelSettingsIcon />, path: "/admin" });
  }


  
const drawerContent = (
  <Box sx={{ width: drawerWidth }}>
    {/* Logo at the top */}
    <Box sx={{ textAlign: "center", mt: 2, mb: 2 }}>
      <img
        style={{
          width: "90%",
          maxWidth: "150px",
          paddingTop: "5px",
          paddingBottom: "5px",
          margin: "5px 16px",
        }}
        src="/images/logo.png"
        alt="Logo"
      />
    </Box>

    <Divider />

    {loadingAdmin ? (
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <CircularProgress size={24} />
      </Box>
    ) : (
      <List>
        {navItems.map((item, index) =>
          item.divider ? (
            <Divider key={`divider-${index}`} sx={{ my: 1 }} />
          ) : (
            <ListItem key={index} disablePadding>
              <ListItemButton component={Link} to={item.path} onClick={toggleDrawer}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          )
        )}
      </List>
    )}
  </Box>
);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* Top Navigation Bar */}
      <AppBar position="fixed" sx={{ background:"#fff" /*zIndex: theme.zIndex.drawer + 1*/ }}>
        <Toolbar>
          {isMobile && (
            <IconButton color="inherit" edge="start" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          )}
          {/* Replacing Typography with Image Logo */}
          <img
            style={{
              width: "90%",
              maxWidth: "150px",
              paddingTop: "5px",
              paddingBottom: "5px",
              margin: "5px 16px",
            }}
            src="/images/logo.png"
            alt="Logo"
          />
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer for Desktop */}
      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Drawer (Collapsible Sidebar) for Mobile */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggleDrawer}
          sx={{
            [`& .MuiDrawer-paper`]: { width: drawerWidth },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Header;
